// import React from "react";
import { WhyChooseUsRealEstateData } from "../../lib/constants";
import { WhyChooseUsEstateItem } from "../../types";
import TextFade from "../../components/CustomTexts/TextFade";
// import WhyChooseUsEstateTile from "../../components/Tiles/WhyChooseUsEstateTile";
import Button from "../../components/Buttons/Button";
import CardBG from "../../assets/chysonfries.jpg";

const WhyChooseUsRealEstate = () => {
  return (
    <div className="bg-dark px-[5%] py-20 flex flex-col items-center">
      <TextFade animation="fade-down">
        <h1 className="md:text-[60px] text-center text-[30px] font-bold text-white">
          Why Choose Us
        </h1>
      </TextFade>

      <div className="w-full grid md:grid-cols-3 grid-cols-1 gap-28 my-28">
        {WhyChooseUsRealEstateData.items.map(
          (item: WhyChooseUsEstateItem, index) => (
            <div
              key={index}
              className="relative rounded-[19px] overflow-hidden hover:scale-105 transition-all duration-500 shadow-lg"
              style={{
                backgroundImage: `url(${CardBG})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
              }}
            >
              <div className="w-full h-full bg-[#006451]/70 backdrop-blur-sm rounded-[19px] p-14 flex flex-col gap-5 items-center justify-center">
                <img src={item.icon} alt={item.title} className="w-[50px] h-[50px]" />
                <h1 className="text-white font-semibold text-[22px] text-center">
                  {item.title}
                </h1>
                <p className="text-center text-white text-[14px] font-normal">
                  {item.description}
                </p>
              </div>
            </div>
          )
        )}
      </div>

      <Button value="Schedule a Tour or Purchase" url="/contact" />
      <div className="mb-12"></div>
    </div>
  );
};

export default WhyChooseUsRealEstate;
